// extracted by mini-css-extract-plugin
export default {"draggable":"css_draggable__DYPVf"};